import React from 'react';
import { ReceiptHeader } from './ReceiptHeader';
import { ReceiptPaymentSummary } from './ReceiptPaymentSummary';
import { ReceiptDetails } from './ReceiptDetails';
import { ReceiptFooter } from './ReceiptFooter';
interface ReceiptProps {
  receiptNo: string;
  receiptDate: string;
  bookingRef: string;
  gstRegNo: string;
  tourCode: string;
  paymentMethod: string;
  collectedBy: string;
  printedBy: string;
  currency: string;
  amountReceived: number;
  totalAmount: number;
  balanceDue: number;
  customerName: string;
  paymentTime: string;
  remarks: string;
  notes: string;
  terms: string;
  companyInfo: {
    name: string;
    logo: string;
    address: string;
    contact: string;
  };
}
export function Receipt({
  receiptNo,
  receiptDate,
  bookingRef,
  gstRegNo,
  tourCode,
  paymentMethod,
  collectedBy,
  printedBy,
  currency,
  amountReceived,
  totalAmount,
  balanceDue,
  customerName,
  paymentTime,
  remarks,
  notes,
  terms,
  companyInfo
}: ReceiptProps) {
  // Remove "Receipt issued upon request" from notes
  const cleanedNotes = notes.replace(/Receipt issued upon request\.?\s*/gi, '').trim();
  return <>
      <ReceiptHeader companyInfo={companyInfo} receiptNo={receiptNo} receiptDate={receiptDate} bookingRef={bookingRef} gstRegNo={gstRegNo} tourCode={tourCode} paymentMethod={paymentMethod} collectedBy={collectedBy} printedBy={printedBy} data-id="element-1030" />

      <ReceiptPaymentSummary currency={currency} amountReceived={amountReceived} totalAmount={totalAmount} balanceDue={balanceDue} data-id="element-1031" />

      <ReceiptDetails customerName={customerName} paymentMethod={paymentMethod} paymentTime={paymentTime} remarks={remarks} data-id="element-1032" />

      {/* Notes Section */}
      {cleanedNotes && <div className="mb-6" data-id="element-1033">
          <h3 className="text-xs font-bold text-neutral-900 uppercase tracking-wide mb-2" data-id="element-1034">
            Notes
          </h3>
          <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-4 text-xs text-neutral-600 leading-relaxed whitespace-pre-line" data-id="element-1035">
            {cleanedNotes}
          </div>
        </div>}

      {/* Terms & Conditions Section */}
      {terms && <div className="mb-8" data-id="element-1036">
          <h3 className="text-xs font-bold text-neutral-900 uppercase tracking-wide mb-2" data-id="element-1037">
            Terms & Conditions
          </h3>
          <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-4 text-xs text-neutral-600 leading-relaxed whitespace-pre-line" data-id="element-1038">
            {terms}
          </div>
        </div>}

      <ReceiptFooter data-id="element-1039" />
    </>;
}